var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmIconGraphics(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.143 23.6941C119.672 24.2112 120 24.9255 120 25.7141C120 26.5026 119.672 27.2169 119.143 27.7341C118.613 28.2512 117.881 28.5712 117.073 28.5712C115.458 28.5712 114.146 27.2912 114.146 25.7141C114.146 24.9255 114.474 24.2112 115.004 23.6941C115.534 23.1769 116.266 22.8569 117.073 22.8569C117.881 22.8569 118.613 23.1769 119.143 23.6941Z",
    fill: "#94D4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.435 109.409C107.965 109.926 108.293 110.641 108.293 111.429C108.293 112.217 107.965 112.932 107.435 113.449C106.905 113.966 106.173 114.286 105.366 114.286C103.75 114.286 102.439 113.006 102.439 111.429C102.439 110.64 102.767 109.926 103.297 109.409C103.827 108.892 104.558 108.572 105.366 108.572C106.173 108.572 106.905 108.892 107.435 109.409Z",
    fill: "#94D4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.976 0C105.018 0 108.293 3.19714 108.293 7.14286C108.293 11.0886 105.018 14.2857 100.976 14.2857C96.9338 14.2857 93.6587 11.0886 93.6587 7.14286C93.6587 3.19714 96.9338 0 100.976 0Z",
    fill: "#F88F19"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4144 111.429C85.8378 111.429 87.8047 113.349 87.8047 115.714C87.8047 118.08 85.8378 120 83.4144 120C80.991 120 79.0242 118.08 79.0242 115.714C79.0242 113.349 80.9907 111.429 83.4144 111.429Z",
    fill: "#F88F19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1668 6.81126C78.6965 7.32841 79.0243 8.04269 79.0243 8.83126C79.0243 9.61984 78.6965 10.3341 78.1668 10.8513C77.6367 11.3684 76.905 11.6884 76.0975 11.6884C74.4819 11.6884 73.1707 10.4084 73.1707 8.83126C73.1707 8.04269 73.4985 7.32841 74.0282 6.81126C74.5583 6.29412 75.29 5.97412 76.0975 5.97412C76.905 5.97412 77.6367 6.29412 78.1668 6.81126Z",
    fill: "#94D4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5327 115.123C64.0625 115.64 64.3903 116.355 64.3903 117.143C64.3903 117.931 64.0625 118.646 63.5327 119.163C63.0027 119.68 62.271 120 61.4635 120C59.8478 120 58.5366 118.72 58.5366 117.143C58.5366 116.354 58.8644 115.64 59.3942 115.123C59.9242 114.606 60.6559 114.286 61.4635 114.286C62.271 114.286 63.0027 114.606 63.5327 115.123Z",
    fill: "#94D4FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0446 3.69408C43.5747 4.21122 43.9025 4.92551 43.9025 5.71408C43.9025 6.50265 43.5747 7.21693 43.0446 7.73408C42.5149 8.25122 41.7832 8.57122 40.9757 8.57122C39.3598 8.57122 38.0488 7.29122 38.0488 5.71408C38.0488 4.92551 38.3766 4.21122 38.9064 3.69408C39.4364 3.17693 40.1681 2.85693 40.9757 2.85693C41.7832 2.85693 42.5149 3.17693 43.0446 3.69408Z",
    fill: "#94D4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6342 5.71436C17.8683 5.71436 20.4878 8.2715 20.4878 11.4286C20.4878 14.5858 17.8683 17.1429 14.6342 17.1429C11.4 17.1429 8.78052 14.5858 8.78052 11.4286C8.78052 8.2715 11.4 5.71436 14.6342 5.71436Z",
    fill: "#F88F19"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99581 106.551C5.52585 107.069 5.85366 107.783 5.85366 108.571C5.85366 109.36 5.52585 110.074 4.99581 110.592C4.46605 111.109 3.73434 111.429 2.92683 111.429C1.31093 111.429 0 110.149 0 108.571C0 107.783 0.327805 107.069 0.857561 106.551C1.38761 106.034 2.11932 105.714 2.92683 105.714C3.73434 105.714 4.46605 106.034 4.99581 106.551Z",
    fill: "#94D4FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3333 81.6667V51H88.6666V81.6667C88.6666 83.1333 87.4666 84.3333 85.9999 84.3333H37.9999C36.5333 84.3333 35.3333 83.1333 35.3333 81.6667Z",
    fill: "#C1E8FB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6666 44.3332V50.9998H35.3333V44.3332C35.3333 42.8665 36.5333 41.6665 37.9999 41.6665H85.9999C87.4666 41.6665 88.6666 42.8665 88.6666 44.3332Z",
    fill: "#2760AD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48.3335C41.1046 48.3335 42 47.4381 42 46.3335C42 45.2289 41.1046 44.3335 40 44.3335C38.8954 44.3335 38 45.2289 38 46.3335C38 47.4381 38.8954 48.3335 40 48.3335Z",
    fill: "url(#paint0_linear_2091_28059)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6667 48.3335C47.7713 48.3335 48.6667 47.4381 48.6667 46.3335C48.6667 45.2289 47.7713 44.3335 46.6667 44.3335C45.5622 44.3335 44.6667 45.2289 44.6667 46.3335C44.6667 47.4381 45.5622 48.3335 46.6667 48.3335Z",
    fill: "url(#paint1_linear_2091_28059)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3333 48.3335C54.4378 48.3335 55.3333 47.4381 55.3333 46.3335C55.3333 45.2289 54.4378 44.3335 53.3333 44.3335C52.2287 44.3335 51.3333 45.2289 51.3333 46.3335C51.3333 47.4381 52.2287 48.3335 53.3333 48.3335Z",
    fill: "url(#paint2_linear_2091_28059)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9999 81.6668C93.9999 89.0295 88.0293 95.0002 80.6666 95.0002C73.3039 95.0002 67.3333 89.0295 67.3333 81.6668C67.3333 74.3042 73.3039 68.3335 80.6666 68.3335C88.0293 68.3335 93.9999 74.3042 93.9999 81.6668Z",
    fill: "url(#paint3_linear_2091_28059)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8611 87.4721L73.5278 82.1388C73.2678 81.8788 73.2678 81.4561 73.5278 81.1961L74.4704 80.2534C74.7304 79.9934 75.1531 79.9934 75.4131 80.2534L79.3331 84.1721L86.5851 76.9201C86.8451 76.6601 87.2678 76.6601 87.5278 76.9201L88.4704 77.8628C88.7304 78.1228 88.7304 78.5454 88.4704 78.8054L79.8038 87.4721C79.5438 87.7321 79.1224 87.7321 78.8611 87.4721Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2091_28059",
    x1: 39.0013,
    y1: 44.8882,
    x2: 40.7093,
    y2: 47.3588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49BEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2091_28059",
    x1: 45.6681,
    y1: 44.8882,
    x2: 47.3761,
    y2: 47.3588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49BEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2091_28059",
    x1: 52.3346,
    y1: 44.8882,
    x2: 54.0426,
    y2: 47.3588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49BEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2091_28059",
    x1: 71.2386,
    y1: 72.2388,
    x2: 90.0946,
    y2: 91.0948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B27D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmIconGraphics);
export default __webpack_public_path__ + "static/media/confirm-icon-graphics.2922dbd0359588b1d4828cec9c010920.svg";
export { ForwardRef as ReactComponent };